<template>
  <div
    v-if="filter?.length > 0"
    class="s-playing-now__options__filters__element">
    <select
      v-model="currentValue"
      :disabled="isDisabled"
      class="form-select"
      :class="{ 'form-select--mobile': !isDesktop }">
      <option value="All" selected>
        {{ placeholder }}
      </option>
      <option
        v-for="filterOption in filter"
        :key="filterOption.value"
        :value="filterOption.value"
        :disabled="isOptionDisabled(filterOption)">
        {{ filterOption.display }}
      </option>
    </select>
  </div>
</template>

<script>
import useViewport from '../../features/viewport.js'

export default {
  props: {
    placeholder: {
      default: 'All',
      type: String,
    },
    filter: {
      default() {
        return []
      },
      type: Array,
    },
    filterName: {
      default: '',
      type: String,
    },
    value: {
      default: 'All',
      type: String,
    },
  },
  emits: ['changed'],
  data() {
    return {
      viewport: useViewport(),
      currentValue: this.value,
    }
  },
  computed: {
    isDesktop() {
      return this.viewport && this.viewport.desktop
    },
    isDisabled() {
      return this.filter.length === 0
    },
  },
  watch: {
    currentValue(newVal) {
      this.$emit('changed', newVal, this.filterName)
    },
    value(newVal) {
      this.$nextTick(() => {
        this.updateCurrentValue(newVal)
      })
    },
  },
  methods: {
    filterOptions(newVal) {
      this.updateCurrentValue(newVal)
    },
    updateCurrentValue(newVal) {
      const isValueInFilters = this.filter.some((item) => item.value === newVal)

      this.currentValue = isValueInFilters ? newVal : 'All'
    },
    isOptionDisabled(option) {
      return option.isDisabled === true || option.isOnline === false
    },
  },
}
</script>
